(ns common.schema.entities.exit-opportunity.core
  (:require [common.schema.entities.exit-opportunity.permissions :as permissions]
            [common.schema.entities.exit-opportunity.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/exit-opportunity
   :schema                       schema/schema
   :name                         {:en "Exit opportunity"}
   :plural                       {:en "Exit opportunities"}
   :icon                         :fa-search-dollar
   :create-icon                  :fa-door-open

   :display-name-fn              (fn [{:keys [entity]}]
                                   (:exit-opportunity/name entity))
   :display-name/depends-on      [:exit-opportunity/name]

   :search                       {:result/title-attr     :exit-opportunity/name
                                  :result/subtitle-attrs [:exit-opportunity/status
                                                          :exit-opportunity/stage]
                                  :indexing              {:change-listening?         true
                                                          :select-searchable?        true
                                                          :dedicated-index?          true
                                                          :associated-entity-fields  #{:exit-opportunity/buyer}
                                                          :name-field                "extras.full-name"
                                                          :universal-filters         {[:extras :pipeline] {:type "number"}}
                                                          :show-in-universal-search? true
                                                          :flattened-ref-policies
                                                          {:exit-opportunity/buyer
                                                           {:policy :policy/target-gate
                                                            :root-visible-fields [:investor/legal-entity]
                                                            :rationale
                                                            (str "[:exit-opportunity/buyer :investor/legal-entity] ships as a "
                                                                 "default grid column, a :po-default-field-path and a kanban "
                                                                 "body field below, so the target's own gate would take a "
                                                                 "visible column away from a pipeline-team member without "
                                                                 ":module/fundraising. Granted as a leaf only - the rest of "
                                                                 "investor's schema still needs :module/fundraising, and there "
                                                                 "is no recursion into the company/person under it.")}}}
                                  :list/default-columns  [:exit-opportunity/name
                                                          [:exit-opportunity/buyer :investor/legal-entity]
                                                          :exit-opportunity/stage
                                                          :exit-opportunity/status
                                                          :exit-opportunity/cur-expected-EV]
                                  :list/default-sort     [:exit-opportunity/name :asc]
                                  :quick-filters         [:exit-opportunity/status
                                                          :exit-opportunity/stage]
                                  :views                 {:grid   {:po-default-field-paths [[:exit-opportunity/name]
                                                                                            [:exit-opportunity/buyer :investor/legal-entity]
                                                                                            [:exit-opportunity/stage]
                                                                                            [:exit-opportunity/status]
                                                                                            [:exit-opportunity/cur-expected-EV]]
                                                                   :mandatory-field-paths  [[:exit-opportunity/name]]
                                                                   :pinned-field-paths     {:left [[:exit-opportunity/name]]}}
                                                          :kanban {:group-by-field :exit-opportunity/stage
                                                                   :card           {:header-fields [:exit-opportunity/name]
                                                                                    :body-fields   [[:exit-opportunity/buyer :investor/legal-entity]
                                                                                                    :exit-opportunity/status
                                                                                                    :exit-opportunity/cur-expected-EV
                                                                                                    :exit-opportunity/owner]
                                                                                    :footer-fields [:common/updated-on]
                                                                                    :meta-fields   [:exit-opportunity/status]}}}}

   :reporting                    {:export/default-fields
                                  [:exit-opportunity/name
                                   :exit-opportunity/stage
                                   :exit-opportunity/status
                                   :exit-opportunity/cur-expected-EV
                                   :common/created-on
                                   :common/updated-on]
                                  :export/filename-template "exit_opportunities_{{date}}.csv"}

   :permissions                  {:creatable?   true
                                  :disableable? true}

   :mcp                          {:creatable? true}

   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
